export default __webpack_public_path__ + "static/media/TBDG 58_So tai chinh Tra Vinh_Phong CC so 1.bcbe2b00.pdf";